import App from '../App'
const _import_ = file => () => import('@/views/' + file + '.vue')

export const RouterMap = [
  {
    path: '/',
    component: App,
    children: [
      {
        path: '',
        redirect: '/tabBar/home/index' // 换乘页改为首页
      },
      {
        path: '/tabBar/home/index', // 首页
        name: 'home',
        component: _import_('tabBar/home/index')
      },
      {
        path: '/tabBar/transfer/index', // 地图换乘
        name: 'transfer',
        component: _import_('tabBar/transfer/index')
      },
      {
        path: '/searchPage/index', //搜索页
        name: 'searchPage',
        component: _import_('searchPage/index')
      },
      {
        path: '/stationDetails/index', //站点的详情信息
        name: 'stationDetails',
        component: _import_('stationDetails/index')
      },
      {
        path: '/stationDetails/stationMap', //站点的地图
        name: 'stationMap',
        component: _import_('stationDetails/stationMap')
      },
      
      {
        path: '/lineDetails/index', //站点下某条线路信息
        name: 'lineDetails',
        component: _import_('lineDetails/index')
      },
      {
        path: '/lineDetails/lineMap', //站点下某条线路地图
        name: 'lineMap',
        component: _import_('lineDetails/lineMap')
      },
      {
        path: '/Transfer/searchStation',
        name: 'searchStation',
        component: _import_('Transfer/searchStation')
      },
      {
        path: '/Transfer/mapDragPoint',
        name: 'mapDragPoint',
        component: _import_('Transfer/mapDragPoint')
      },
      {
        path: '/Transfer/mapLine',
        name: 'mapLine',
        component: _import_('Transfer/mapLine')
      },
      {
        path: '/mapPage/index',
        name: 'mapPage',
        component: _import_('mapPage/index')
      },
      {//测试页面
        path: '/test/index',
        name: 'testPage',
        component: _import_('test/index')
      }
    ]
  }
]
